import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IQuizCurrentState, IQuizState } from ".";
import { now } from "../../utils/time";

export interface IRequestQuizQuestionResponse extends IQuizCurrentState {};

export const requestQuizQuestion = createAsyncThunk<IRequestQuizQuestionResponse>(
    'quiz.requestQuizQuestion',
    async () => await api.quizzes.requestQuestion()
);

const requestQuizQuestionHandler = (builder: ActionReducerMapBuilder<IQuizState>) => {
    builder
        .addCase(requestQuizQuestion.pending, (state: IQuizState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(requestQuizQuestion.fulfilled, (state: IQuizState, action: PayloadAction<IRequestQuizQuestionResponse>) => {
            state.loading = false;
            state.quiz = action.payload;
            state.answerResult = null;
            state.isExpired = false;

            if (state.quiz)
                state.deltaTime = now() - state.quiz.now;
        })
        .addCase(requestQuizQuestion.rejected, (state: IQuizState) => {
            state.loading = false;
            state.error = 'Unable to request quiz question';
        });
};

export default requestQuizQuestionHandler;